import { Box, Icon, Text } from "@prismicio/editor-ui"

interface OnboardingTutorialProps {
  href: string
}
export function OnboardingTutorial(props: OnboardingTutorialProps) {
  const { href } = props

  return (
    <Box justifyContent="center" padding={{ block: 6 }}>
      <Text href={href} variant="smallBold" color="grey11">
        Or watch our in-depth course
        <Icon
          name="playCircle"
          color="grey11"
          size="small"
          sx={{ marginLeft: 4 }}
        />
      </Text>
    </Box>
  )
}
